import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "relative overflow-x-auto shadow-md sm:rounded-lg" };
var _hoisted_2 = { class: "w-full text-sm text-left text-gray-500 dark:text-gray-400" };
var _hoisted_3 = { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" };
var _hoisted_4 = ["value"];
var _hoisted_5 = { key: 0 };
var _hoisted_6 = ["colspan"];
import { onMounted } from 'vue';
import { initFlowbite } from 'flowbite';
import { Modal } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SearchResultTable',
    props: {
        labels: Array,
        filteredData: Array,
        displayedColumns: Array,
        searchWord: String,
    },
    setup: function (__props) {
        var props = __props;
        onMounted(function () {
            initFlowbite();
        });
        // const emit = defineEmits<{
        // }>();
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_unref(Modal), null, {
                header: _withCtx(function () { return [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Tu hai cercato per:')) + " " + _toDisplayString(__props.searchWord), 1)
                ]; }),
                body: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("table", _hoisted_2, [
                            _createElementVNode("thead", _hoisted_3, [
                                _createElementVNode("tr", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.labels, function (label, index) {
                                        return (_openBlock(), _createElementBlock("th", {
                                            scope: "col",
                                            class: "px-6 py-3",
                                            value: label,
                                            key: index
                                        }, _toDisplayString(label), 9, _hoisted_4));
                                    }), 128))
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (__props.filteredData.length == 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                                        _createElementVNode("td", {
                                            colspan: __props.labels.length,
                                            style: { "text-align": "center", "color": "red", "font-size": "large", "font-weight": "bold", "padding-top": "2%", "padding-bottom": "2%" }
                                        }, _toDisplayString(_ctx.$t('nessuna data')), 9, _hoisted_6)
                                    ]))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.filteredData, function (row, rowIndex) {
                                        return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.displayedColumns, function (column, columnIndex) {
                                                return (_openBlock(), _createElementBlock("td", { key: columnIndex }, _toDisplayString(row[column]), 1));
                                            }), 128))
                                        ]));
                                    }), 128))
                            ])
                        ])
                    ])
                ]; }),
                _: 1
            }));
        };
    }
});
